/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GcpCloudRunJobExecutionResponse { 
    /**
     * Cloud run job execution name.
     */
    name?: string;
    /**
     * Cloud run job execution UID.
     */
    uid?: string;
    /**
     * Cloud run job in execution.
     */
    job?: string;
}

